<template>
    <footer class="bg-white px-6 max-w-7xl mx-auto pb-10 font-normal border-t pt-11 md:pt-0">
        
        <!-- Wide View -->
        <div class="hidden md:flex max-w-7xl mx-auto pt-12 pb-20 px-5 justify-between">
            <div class="flex text-sm text-zinc-500">
                <ul class="ml-0 w-32 md:m-0">
                    <li class="mb-3 text-black bg-white header-font-size">About</li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="http://hike.cau.ac.kr" target="blank" class="text-sm">HIKE</a></li>
                </ul>

                <ul class="w-32 md:w-52 md:ml-0 md:m-0">
                    <div class="mb-3 text-black header-font-size bg-white">Channels</div>
                    <li class="mb-1.5 font-normal hover:underline"><a href="https://labs.datahub.kr/query" target="blank">Query</a></li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="https://vocab.datahub.kr" target="blank">Vocabulary</a></li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="https://labs.datahub.kr/projects/datamap/datamap-status" target="blank">Category</a></li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="https://labs.datahub.kr/projects/datamap" target="blank">Datamap Dashboard</a></li>
                </ul>

                <ul class="w-32 md:w-52 md:ml-0 md:m-0">
                    <div class="mb-3 text-black header-font-size bg-white">Collaboration</div>
                    <li class="mb-1.5 font-normal hover:underline"><a href="http://okfn.kr/projects/covid-19-our-memory/" target="blank">Team.Cayley</a></li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="http://forum.datahub.kr" target="blank">Open Knowledge Forum</a></li>
                    <li class="mb-1.5 font-normal hover:underline"><a href="http://okfn.kr/" target="blank">Open Knowledge Korea</a></li>
                </ul>
            </div>

            <div>
                <div class="text-sm text-zinc-500 bg-white mt-3 md:mt-0 mb-3 text-center md:text-right">
                    ⓒ 2022 Stealth Lab | HIKE Lab. <br> All Rights Reserved.
                </div>
            </div>
        </div>

        <!-- Mobile View -->
        <div class="md:hidden flex flex-col px-3 text-base">
            <ul class="mb-3">
                <li class="mb-3 font-medium text-gray-700 text-center">About</li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="http://hike.cau.ac.kr" target="blank">HIKE</a></li>
            </ul>
            <ul class="mb-3">
                <li class="mb-3 font-medium text-gray-700 text-center">Channels</li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="https://labs.datahub.kr/query" target="blank">Query</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="https://vocab.datahub.kr" target="blank">Vocabulary</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="https://labs.datahub.kr/projects/datamap/datamap-status" target="blank">Category</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="https://labs.datahub.kr/projects/datamap" target="blank">Datamap Dashboard</a></li>
            </ul>
            <ul class="mb-3">
                <li class="mb-3 font-medium text-gray-700 text-center">Collaboration</li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="http://okfn.kr/projects/covid-19-our-memory/" target="blank">Team.Cayley</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="http://forum.datahub.kr" target="blank">Open Knowledge Forum</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="https://labs.datahub.kr/projects/datamap/datamap-status" target="blank">Category</a></li>
                <li class="mb-1.5 font-normal text-gray-500 hover:underline text-sm text-center"><a href="http://okfn.kr/" target="blank">Open Knowledge Korea</a></li>
            </ul>
            <div>
                <div class="text-sm md:text-base text-gray-500 mt-3 md:mt-0 mb-3 text-center md:text-right">
                    ⓒ 2022 Stealth Lab | HIKE Lab. <br> All Rights Reserved.
                </div>
            </div>
        </div>
        

    </footer>

</template>

<script>
export default {
    name: 'FooterView',
};
</script>